import { render, staticRenderFns } from "./SiderRight.vue?vue&type=template&id=ce4f6fde&"
import script from "./SiderRight.vue?vue&type=script&lang=js&"
export * from "./SiderRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports